import * as fromRoot from '../../state';
import {
  ActionReducerMap,
  createFeatureSelector,
  createSelector
} from '@ngrx/store';
import { HomeState } from './states/home.state';
import { HomeReducer } from './reducers/home.reducers';
import { profileUserReducer } from './reducers/profile-user.reducer';
import { ProfileUserState } from './states/profile-user.state';
import { UserConnectionsReducer } from './reducers/user-connections.reducer';
import { UserConnectionsModel } from './states/user-connections.model';
import { peopleToFollowReducers } from './reducers/people-to-follow.reducers';
import { PeopleToFollowState } from './states/people-to-follow.state';
import { TrendingHashState } from './states/trending-hash.state';
import { trendingHashReducer } from './reducers/trending-hash.reducers';
import { NotificationState } from './states/notification.state';
import { NotificationReducer } from './reducers/notification.reducer';
import { DmState } from './states/dm.state';
import { DirectMessageReducer } from './reducers/direct-message.reducer';
import { GroupsState } from './states/groups.state';
import { GroupsReducer } from './reducers/groups.reducer';

export interface State extends fromRoot.State {
  home?: HomeState;
  profileUser?: ProfileUserState;
  userConnections?: UserConnectionsModel;
  peopleToFollow?: PeopleToFollowState;
  trendingHash?: TrendingHashState;
  notification?: NotificationState;
  directMessages?: DmState;
  groups?: GroupsState;
}

export const reducer: ActionReducerMap<State> = {
  home: HomeReducer,
  profileUser: profileUserReducer,
  userConnections: UserConnectionsReducer,
  peopleToFollow: peopleToFollowReducers,
  trendingHash: trendingHashReducer,
  notification: NotificationReducer,
  directMessages: DirectMessageReducer,
  groups: GroupsReducer
};

// global-home
export const getGlobalHomeFeatureStore = createFeatureSelector<State>(
  'global-home'
);

// selectors function
const getHomeFeatureStore = createSelector(
  getGlobalHomeFeatureStore,
  state => state.home
);

export const getPostFormState = createSelector(
  getHomeFeatureStore,
  state => state.postFormState
);

export const getUploadingImages = createSelector(
  getPostFormState,
  state => state.uploadFiles
);

export const getUploadingVideos = createSelector(
  getPostFormState,
  state => state.uploadVideos
);

export const getPostFormType = createSelector(
  getPostFormState,
  state => state.formType
);

export const getPostsState = createSelector(
  getHomeFeatureStore,
  state => state.postsState
);

export const getPostsError = createSelector(
  getHomeFeatureStore,
  state => state.feedError
);

export const getLoadMorePostsError = createSelector(
  getHomeFeatureStore,
  state => state.feedLoadMoreError
);

export const getPostsLoading = createSelector(
  getHomeFeatureStore,
  state => state.feedLoading
);

export const getNewPostState = createSelector(
  getHomeFeatureStore,
  state => state.newPostState
);

export const getSocialUser = createSelector(
  getHomeFeatureStore,
  state => state.socialUser
);
export const getPostPagination = createSelector(
  getHomeFeatureStore,
  state => state.postPagination
);
